import { Locale } from '@nx-ahs/base-translate';

//import { Locale } from '@ahsxp/base-translate';

export const locale: Locale = {
	lang: 'cr',
	data: {
		TEST: 'SP: secure-messaging works!!!!!!!!!!!!!!!!!!!!!!!!',
		ACCOUNT_INFORMATION: 'SP: Account Information',
		ADD_MEMBER: 'SP: Add Member',
		AT: ' - ',
		CANCEL: 'Anile',
		CANNOT_REPLY: 'Mesaj sa a make kòm fèmen epi yo pa ka reponn a li.',
		CLEAR: 'SP: Clear',
		CLOSE: 'SP: Close',
		CLOSED: 'Fèmen',
		CLOSE_TASK_MESSAGE_WARNING: 'Èske ou sèten ou vle make mesaj sa a kòm fèmen?',
		CONTACT_CENTER: 'Biwo èd',
		CONTACT_PREFERENCE: 'Mwen ta prefere ou kontakte mwen pa:',
		CONTACT_PREFERENCE_ERROR: 'CR: Please choose a contact preference',
		CONVERSATION: 'SP: Conversation',
		DATE: 'Dat',
		DESCRIPTION:
			'Èske ou bezwen èd? Voye yon mesaj ba nou epi nou ap reponn ou nan espas 8 èdtan ouvrab. Pou w pale avèk nou, tanpri rele nan 1-888-540-KIDS (5437) lasemèn ant 7:30 AM ak 7:30 PM, Lè Lès.',
		FILTER_ON_MESSAGE_STATUS: 'SP: Filter on message status:',
		LAST_MESSAGE_RECIEVED: 'SP: Last Message Received On',
		MARK_OPEN: 'Make li Louvri',
		MARK_CLOSED: 'Mak Fèmen?',
		MARKED_CLOSED_BY: 'Mak fèmen a ',
		MESSAGE: 'SP: Message',
		MESSAGE_ERROR: 'Tanpri antre yon mesaj',
		MESSAGE_STATUS: 'CR: Message Status',
		NEW_SECURE_MESSAGE: 'Nouvo Mesaj',
		OPEN: 'Ouvri',
		CONVERSATION_PHONE: 'Nimewo Telefòn',
		PHONENUMBER_ERROR: 'Tanpri antre yon nimewo telefòn',
		PHONENUMBER_LABEL: 'Tanpri antre yon nimewo telefòn',
		PAYMENT_PORTAL: 'SP: Premium Portal',
		PREFERRED_CONTACT_TIME: 'Tan pi pito nan jounen an',
		RECURRING_PAYMENTS: 'SP: Recurring Payments',
		PREMIUM_AMOUNT: 'SP: Premium Amount',
		REGARDING: 'Ki aplikab pou manm sa a:',
		REGARDING_ERROR: 'Tanpri chwazi yon manm',
		SEARCH_MESSAGES: 'Chèche Mesaj',
		SELECT_ANY: 'SP: Select Any',
		SELECT_A_MEMBER: 'Selecciona un miembro',
		SEND: 'Voye',
		STATUS: 'Estati',
		SUBJECT: 'Mwen gen yon kesyon oswa enkyetid sou:',
		SUBJECT_ERROR: 'Tampri chwazi yon Sijè',
		TITLE: 'Mesaj',
		TO_START_NEW_MESSAGE: 'SP: To start a new message click',
		TYPE_MESSAGE_HERE: 'Tanpri tape mesaj ou a la a',
		VIEW_MESSAGE: 'Ouvri mesaj',
		VIEW_MESSAGES: 'Mesaj',
		SecureMessage: 'Mesaj an Sekirite',
		Call: 'Apèl Telefòn',
		Other: 'Lòt',
		EligibilityCoverage: 'Elijiblite / Pwoteksyon',
		EnrollmentPlanChange: 'Enskripsyon / Plan Chanjman',
		IDCards: 'Kat ID',
		Medicare: 'Medicare',
		Payment: 'Peman',
		PersonalInformation: 'Enfomasyon Pèsonèl',
		Services: 'Sèvis',
		YES: 'Wi',
		NO: 'Non',
		REOPEN: 'Relouvri',
		STATUS_CHANGED_TO: 'Estati chanje an '
	}
};
